module.exports = __webpack_public_path__ + "ec9a6fbbfb857117f50862c67aee9b1c.svg";